import format from 'date-fns/format';

import { create2WeeksList, chunkArray } from '@scrippsproduct/networks-ui-library/dist/utils/date-helpers';
import getSchedule from '@scrippsproduct/networks-ui-library/dist/hooks/getSchedule';
import { SUPPORT_LINK } from '../settings/Settings';

import { ScheduleLayout } from '@scrippsproduct/networks-ui-library';

import './../scss/Schedule.scss';

const SCHED_EP = process.env.REACT_APP_SCHEDULE_V2;
const NETWORK = process.env.REACT_APP_NETWORK;

export default function Schedule() {
    const weeks = (window.innerWidth > 600) ? chunkArray(create2WeeksList(new Date()), 7) : chunkArray(create2WeeksList(), 7);
    const fetchSchedule = async (day) => {
        const res = await getSchedule({ 
            dateStr: format(day, 'yyyy-MM-dd'),
            schedEndpoint: SCHED_EP,
            network: NETWORK,
        });
    
        return res;
    };
        
    return (<>
            <ScheduleLayout
                fetchSchedule={ fetchSchedule }
                weeks={ weeks }
                supportLink={ SUPPORT_LINK }
            />     
    </>);
}
